import ContractsCargoTaxiUpdateParams from "../../../../../common/services/contracts/cargo-taxi/update/contracts-cargo-taxi-update-params";
import TaxiCargoContractEditFormData from "./types/taxi-cargo-contract-edit-form-data";

const create = (
  formData: TaxiCargoContractEditFormData,
  contractUuid: string,
): ContractsCargoTaxiUpdateParams => {
  return {
    contractUuid: contractUuid,
    cancelOrderByTaxiAllowed: formData.cancelOrderByTaxiAllowed,
    contactPassengerAfterMinutes: formData.contactPassengerAfterMinutes,
    editOrderByTaxiAllowed: formData.editOrderByTaxiAllowed,
    isActive: formData.isActive!,
  };
};

const taxiCargoContractEditFormRequestFactory = {
  create,
};

export default taxiCargoContractEditFormRequestFactory;
